import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import store from "@/store";
import { getToken, removeToken } from "@/utils/auth";

// 业务相关
const ALL_CODE = {
  NOT_LOGIN: 1001, // 登录失效
  SUCCESS: 0, //数据请求成功
};

const service = axios.create({
  // baseURL: "https://bole-api.sccxqc.cn/", // 测试地址
  baseURL: "https://api.bl-creation.cn/", // 生产地址
  timeout: 5000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示加载状态
    // Message({
    //   message: "正在加载，请稍候...",
    //   type: "success",
    //   duration: 0, // 不自动关闭
    //   showClose: true,
    // });

    config.headers = {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "111",
      ...config.headers,
    };

    // 添加 token 到请求头
    const token = getToken();
    if (token) {
      config.headers["token"] = `${token}`;
    }

    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 关闭加载状态
    // Message.closeAll();
    const { config, data, status } = response;
    const res = response.data;
    // 检查响应类型，确保它是二进制文件
    const contentType = response.headers["content-type"];
    if (
      contentType === "application/vnd.ms-excel" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" ||
      contentType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      contentType === "application/zip" ||
      contentType.includes("application/octet-stream")
    ) {
      if (status === 200) {
        return response; // 返回整个 response，包含 headers 和 blob 数据
      } else {
        return Promise.reject(new Error("网络问题，请稍后重试"));
      }
    }

    if (contentType.includes("application/pdf")) {
      return response; // 返回整个 response，包含 headers 和 blob 数据
    }

    // 先判断状态码是否正常
    if (status !== 200) {
      return Promise.reject(new Error("网络问题，请稍后重试"));
    } else {
      if (data.code === ALL_CODE.NOT_LOGIN) {
        // 提示弹窗
        Message.error("登录失效，请重新登录");
        removeToken();
        localStorage.removeItem("user_permissions");
        location.reload();
      } else if (data.code === ALL_CODE.SUCCESS) {
        return data.data || {};
      } else {
        console.log(data);
        Message.error(data.msg || "请求失败");
        return Promise.reject(new Error(data.msg || "请求失败"));
      }
    }
  },
  (error) => {
    // 关闭加载状态
    // Message.closeAll();

    if (error.message.includes("timeout")) {
      Message.error("请求超时，请检查网络或稍后重试");
    } else {
      Message.error("请求错误，请稍后重试");
    }

    return Promise.reject(error);
  }
);

export default service;
